import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { unFormatCurrency, unFormatUnknownUnit } from "@/common/utils/unFormatters";
import { AxiosResponse } from "axios";
import { NegotiationValidationSchema } from "../schemas/negotiation.schema";
import { ErrorResponse } from "@/common/types/errorResponse";

interface UseCreateNegotiation {
  establishmentId?: string;
  onSuccess: (response: AxiosResponse) => void,
  onError: (error: ErrorResponse) => void,
}

const useCreateNegotiation = ({ establishmentId, onSuccess, onError }: UseCreateNegotiation) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createNegotiation'],
    mutationFn: async (form: NegotiationValidationSchema) => {
      const payload = {
        establishment_company_id: establishmentId,
        observation: form.observation || '',
        negotiation_products_attributes: form.negotiation_products_attributes.map((formNegotiationProduct) => ({
          product_id: formNegotiationProduct.product_id,
          value: formNegotiationProduct.value ? unFormatCurrency(formNegotiationProduct.value) : undefined,
          quantity: formNegotiationProduct.quantity ? unFormatUnknownUnit(formNegotiationProduct.quantity) : undefined,
        })),
      };

      return privateAxios.post('/negotiations', payload);
    },
    onSuccess,
    onError,
  });
};

export default useCreateNegotiation;
